module.exports = __webpack_public_path__ + "static/media/3 Black.0c53a333.svg";